import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {InformType} from '../../../../global/util/enum/InformType';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {Installer} from '../../../model/Installer';
import {StringUtil} from '../../../../global/util/StringUtil';
import {InstallerService} from '../../../service/installer.service';
import {Constant} from '../../../../global/util/Constant';
import {MoreAboutInstaller} from '../../../model/common/MoreAboutInstaller';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {Operatingsystem} from '../../../model/Operatingsystem';
import {Signatureapptype} from '../../../model/Signatureapptype';
import {Dialog} from '../../../../global/util/Dialog';
import {Typefile} from '../../../model/Typefile';
import {OperatingSystem} from '../../../../global/util/OperatingSystem';
import {SignatureApplicationType} from '../../../../global/util/SignatureAppType';
import {TypeFile} from '../../../../global/util/TypeFile';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-add-edit-installer',
  templateUrl: './add-edit-installer.component.html',
  styleUrls: ['./add-edit-installer.component.css']
})
export class AddEditInstallerComponent implements OnInit {
  public installer: Installer;
  public moreAboutInstaller: MoreAboutInstaller;
  public loading: boolean;
  public installerForm: FormGroup;
  public purpose4Form: number;
  public currentVersion: string;
  public signatureapptypes: Signatureapptype[] = [];
  public operatingsystems: Operatingsystem[] = [];
  public typefiles: Typefile[] = [];
  public progressUpdate = 0;
  public entityName = 'TITLE.INSTALLERS';

  constructor(public activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private installerService: InstallerService,
              private translate: TranslateService) {
    this.createForm();
  }

  ngOnInit() {
    this.loadInitialData();
    switch (this.purpose4Form) {
      case Constant.ADD:
        this.moreAboutInstaller.operatingsystemId = OperatingSystem.WINDOWS;
        this.moreAboutInstaller.typeApp = SignatureApplicationType.RC_DSGINATURE;
        this.moreAboutInstaller.typefile = TypeFile.EXECUTABLE;
        break;
      case Constant.EDIT:
        this.installerForm.get('appFile').clearValidators();
        this.installerForm.get('appFile').updateValueAndValidity();
        this.installerForm.get('version').clearValidators();
        this.installerForm.get('version').updateValueAndValidity();
        this.installerForm.get('appFilename2Show').clearValidators();
        this.installerForm.get('appFilename2Show').updateValueAndValidity();
        break;
    }
  }

  private loadInitialData() {
    this.signatureapptypes = LocalStorage.getSignatureapptype();
    this.operatingsystems = LocalStorage.getOperatingsystem();
    this.typefiles = LocalStorage.getTypefile();
  }

  public save(): void {
    if (this.installerForm.invalid) {
      Object.values(this.installerForm.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }
    this.loading = true;
    if (this.isNewInstaller) {
      this.register();
    } else {
      this.setFinalValuesBefore2Save();
      this.edit();
    }
  }

  public cancel(): void {
    this.activeModal.close();
  }

  public setFinalValuesBefore2Save() {
    this.installer.newVersionMessage = this.moreAboutInstaller.newVersionMessage;
    this.installer.updatedVersionMessage = this.moreAboutInstaller.updatedVersionMessage;
  }

  public register() {
    const formData = new FormData();
    formData.append('description', String(this.installer.description));
    formData.append('version', this.installer.version);
    formData.append('type', this.installerForm.value.type);
    formData.append('typefile', this.installerForm.value.typeFile);
    formData.append('operatingsystem', this.installerForm.value.operatingSystem);
    formData.append('messageUpdatedVersion', String(this.moreAboutInstaller.updatedVersionMessage));
    formData.append('messageNewVersion', String(this.moreAboutInstaller.newVersionMessage));
    formData.append('appFile', this.installerForm.value.appFile);
    this.installerService.save(formData).subscribe((event: HttpEvent<any>) => {
      switch (event.type) {
        case HttpEventType.Sent:
          // TODO When request has been made
          break;
        case HttpEventType.ResponseHeader:
          // TODO When response header has been received
          break;
        case HttpEventType.UploadProgress:
          this.progressUpdate = Math.round(event.loaded / event.total * 100);
          break;
        case HttpEventType.Response:
          this.loading = false;
          this.activeModal.close(InformType.Success);
          break;
      }
    }, error => {
      this.loading = false;
      if (HttpStatusCode.FOUND === error.status) {
        this.activeModal.close(InformType.Warning);
      } else {
        this.activeModal.close(InformType.Danger);
      }
    });
  }

  public edit() {
    this.installerService.edit(this.installer).subscribe(installer => {
      this.loading = false;
      this.activeModal.close(InformType.Success);
    }, error => {
      this.loading = false;
      if (HttpStatusCode.FOUND === error.status) {
        this.activeModal.close(InformType.Warning);
      } else {
        this.activeModal.close(InformType.Danger);
      }
    });
  }

  get isNewInstaller(): boolean {
    return this.installer.id === undefined;
  }

  private createForm() {
    this.installerForm = this.formBuilder.group(
      {
        appFile: [null, [Validators.required]],
        appFilename2Show: ['', [Validators.required]],
        type: [''],
        operatingSystem: [''],
        typeFile: [''],
        currectVersion: [''],
        description: [''],
        updatedVersionMessage: [''],
        newVersionMessage: [''],
        version: ['', Validators.compose([Validators.required, Validators.pattern('^(?:(\\d+)\\.)+(?:(\\d+)\\.)+(\\*|\\d+)$')])],
        status: ['']
      });
  }

  public isInvalidControl(ctrlName: string) {
    return this.installerForm.get(ctrlName).invalid && this.installerForm.get(ctrlName).touched;
  }

  public changeStatus(event) {
    const fileSelected = (event.target as HTMLInputElement).files[0];
    this.installerForm.patchValue({
      appFile: fileSelected,
      appFilename2Show: StringUtil.cut(fileSelected.name, 42, this.translate.instant('MESSAGE.SELECT')),
    });
    this.installerForm.get('appFile').updateValueAndValidity();
    this.installerForm.get('appFilename2Show').updateValueAndValidity();
  }

  get disableOnEditOnInstallers(): boolean {
    return Constant.EDIT === this.purpose4Form;
  }

  public reloadInstaller() {
    this.getLastVersion();
  }

  public isInstaller(): boolean {
    return this.moreAboutInstaller.typefile === TypeFile.EXECUTABLE;
  }

  public getLastVersion() {
    const url = Constant.ROOT_API_V1
      .concat('/operatingsystems/')
      .concat(String(this.moreAboutInstaller.operatingsystemId))
      .concat('/typefiles/')
      .concat(String(this.moreAboutInstaller.typefile))
      .concat('/signatureapptypes/')
      .concat(String(this.moreAboutInstaller.typeApp))
      .concat('/lastversion');
    this.installerService.get(url).subscribe((signatureApp: any) => {
      this.loading = false;
      if (signatureApp !== null) {
        this.currentVersion = signatureApp.version;
      } else {
        this.currentVersion = '0.0.0';
      }
    }, error => {
      this.loading = false;
      if (HttpStatusCode.UNAUTHORIZED === error.error.status) {
        Dialog.show(InformType.Danger, this.entityName, error.error.message);
      } else {
        Dialog.show(InformType.Danger, this.entityName);
      }
    });
  }

  public isInvalidControlForVersion(ctrlName: string): boolean {
    return !this.isInvalidControl(ctrlName) && !(this.getControl(ctrlName).value !== undefined ? this.isInvalidVersion() : '') ? false : true;
  }

  public isInvalidVersion(): boolean {
    const control = this.getControl('version');
    const control1 = this.getControl('currectVersion');
    if (control.value !== '') {
      const currentVersions = control1.value.split('.');
      const newVersions = control.value.split('.');
      if (Number(currentVersions[0]) > Number(newVersions[0])) {
        this.installerForm.get('version').setErrors({incorrect: true});
        return true;
      } else if (Number(currentVersions[0]) < Number(newVersions[0])) {
        return false;
      } else if (Number(currentVersions[1]) > Number(newVersions[1])) {
        this.installerForm.get('version').setErrors({incorrect: true});
        return true;
      } else if (Number(currentVersions[1]) < Number(newVersions[1])) {
        return false;
      } else if (Number((currentVersions[2])) > Number(newVersions[2])) {
        this.installerForm.get('version').setErrors({incorrect: true});
        return true;
      } else if (Number(currentVersions[2]) < Number(newVersions[2])) {
        return false;
      } else if (control1.value === control.value) {
        this.installerForm.get('version').setErrors({incorrect: true});
        return true;
      } else {
        return false;
      }
    }
  }

  public getControl(ctrlName: string) {
    return this.installerForm.get(ctrlName);
  }

  public getErrorMessageBy(controlName: string): string {
    const control = this.installerForm.get(controlName);
    const hasRequiredError = control.hasError('required');
    const hasPatternError = control.hasError('pattern');
    let actualValue;
    switch (controlName) {
      case 'version':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.ENTER-APPLICATION-VERSION');
        } else if (hasPatternError) {
          actualValue = control.errors.pattern.actualValue;
          return '\''
            .concat(String(actualValue))
            .concat(this.translate.instant('MESSAGE.ENTER-APPLICATION-VERSION'))
            .concat(', ')
            .concat(this.translate.instant('MESSAGE.EXAMPLE'))
            .concat('\'0.0.0\'\ ');
        } else {
          return this.translate.instant('MESSAGE.ENTER-APPLICATION-VERSION');
        }
        break;
    }
  }

  get isActive() {
    return String(this.installer.active) === 'true';
  }
}
